import React from 'react'

import CssFilterConverter from 'css-filter-converter'

import { t } from 'src/translations'

import Image from 'shared/components/common/Image'
import Link from 'shared/components/common/link'

type Props = {
  url: string
  color?: string
  locationName?: string
}

// Warning, this uses partial string matches and it may cause unexpected
// problems if there are any conflicts in social domains.
const SocialLink = ({ url, color, locationName }: Props) => {
  let platform: string | null = null
  let src = null
  const formattedUrl = url.toLowerCase()
  if (formattedUrl.includes('instagram.com')) {
    platform = 'Instagram'
    src = 'icons/instagram-white.svg'
  } else if (
    formattedUrl.includes('twitter.com') ||
    formattedUrl.includes('x.com')
  ) {
    platform = 'X (formerly Twitter)'
    src = 'icons/x-white-1.svg'
  } else if (formattedUrl.includes('pinterest.com')) {
    platform = 'Pinterest'
    src = 'icons/pinterest-white.svg'
  } else if (formattedUrl.includes('facebook.com')) {
    platform = 'Facebook'
    src = 'icons/facebook-white.svg'
  } else if (formattedUrl.includes('yelp.com')) {
    platform = 'Yelp'
    src = 'icons/yelp-white.svg'
  } else if (formattedUrl.includes('tripadvisor.com')) {
    platform = 'Tripadvisor'
    src = 'icons/tripadvisor.svg'
  } else if (formattedUrl.includes('snapchat.com')) {
    platform = 'Snapchat'
    src = 'icons/snapchat-white.webp'
  } else if (formattedUrl.includes('foursquare.com')) {
    platform = 'Foursquare'
    src = 'icons/foursquare.webp'
  } else if (formattedUrl.includes('tiktok.com')) {
    platform = 'TikTok'
    src = 'icons/tiktok-white.svg'
  } else if (formattedUrl.includes('youtube.com')) {
    platform = 'YouTube'
    src = 'icons/youtube-white.svg'
  }
  // make logos (which are by default white) match color (if available) using css filters
  // note - this code will not work as well if logos are not all white
  // TODO: converting all logos to SVG and downloading them to this repo will allow us to apply a simple svg fill instead of a css filter
  // This will allow us to remove the CssFilterConverter and reduce load times
  let style: React.CSSProperties | undefined = undefined
  if (color) {
    const cssFilter = CssFilterConverter.hexToFilter(color).color
    if (cssFilter) {
      style = { filter: cssFilter }
    }
  }
  const imageAlt = platform
    ? t('location-description.platform-logo', { platform })
    : ''
  const linkLabel =
    locationName && platform
      ? t('location-description.social-link-aria', { locationName, platform })
      : imageAlt || ''

  return platform && src ? (
    <Link key={url} href={url} data-testid='social-link' ariaLabel={linkLabel}>
      <Image alt={imageAlt} src={src} style={style} />
    </Link>
  ) : null
}

export default SocialLink
